/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateDocumentV2Dto } from '../models/work-create-document-v-2-dto';
import { WorkDocument } from '../models/work-document';
import { WorkDocxOutputFormatEnum } from '../models/work-docx-output-format-enum';
import { WorkGenerateFromTemplateV3Dto } from '../models/work-generate-from-template-v-3-dto';
import { WorkSuccessDto } from '../models/work-success-dto';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceDocumentsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceDocumentsV2ControllerFindByProject()` */
  static readonly SelfserviceDocumentsV2ControllerFindByProjectPath = '/v2/selfservice/documents/byProject/{projectId}';

  /**
   * Get all documents for a specific project owned by the contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceDocumentsV2ControllerFindByProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceDocumentsV2ControllerFindByProject$Response(
    params: {
      projectId: number;

    /**
     * Take Images too
     */
      withImages?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceDocumentsService.SelfserviceDocumentsV2ControllerFindByProjectPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('withImages', params.withImages, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Get all documents for a specific project owned by the contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceDocumentsV2ControllerFindByProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceDocumentsV2ControllerFindByProject(
    params: {
      projectId: number;

    /**
     * Take Images too
     */
      withImages?: boolean;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.selfserviceDocumentsV2ControllerFindByProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `selfserviceDocumentsV2ControllerDeleteDocument()` */
  static readonly SelfserviceDocumentsV2ControllerDeleteDocumentPath = '/v2/selfservice/documents/deleteDocument/{projectId}/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceDocumentsV2ControllerDeleteDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceDocumentsV2ControllerDeleteDocument$Response(
    params: {
      projectId: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceDocumentsService.SelfserviceDocumentsV2ControllerDeleteDocumentPath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceDocumentsV2ControllerDeleteDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceDocumentsV2ControllerDeleteDocument(
    params: {
      projectId: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.selfserviceDocumentsV2ControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `selfserviceDocumentsV2ControllerGenerateFromTemplate()` */
  static readonly SelfserviceDocumentsV2ControllerGenerateFromTemplatePath = '/v2/selfservice/documents/generateFromTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceDocumentsV2ControllerGenerateFromTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceDocumentsV2ControllerGenerateFromTemplate$Response(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV3Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceDocumentsService.SelfserviceDocumentsV2ControllerGenerateFromTemplatePath, 'post');
    if (params) {
      rb.query('format', params.format, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'blob', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceDocumentsV2ControllerGenerateFromTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceDocumentsV2ControllerGenerateFromTemplate(
    params: {
      format: WorkDocxOutputFormatEnum;
      body: WorkGenerateFromTemplateV3Dto
    },
    context?: HttpContext
  ): Observable<Blob> {
    return this.selfserviceDocumentsV2ControllerGenerateFromTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `selfserviceDocumentsV2ControllerUploadDocument()` */
  static readonly SelfserviceDocumentsV2ControllerUploadDocumentPath = '/v2/selfservice/documents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceDocumentsV2ControllerUploadDocument()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  selfserviceDocumentsV2ControllerUploadDocument$Response(
    params: {
      body: WorkCreateDocumentV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceDocumentsService.SelfserviceDocumentsV2ControllerUploadDocumentPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceDocumentsV2ControllerUploadDocument$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  selfserviceDocumentsV2ControllerUploadDocument(
    params: {
      body: WorkCreateDocumentV2Dto
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.selfserviceDocumentsV2ControllerUploadDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

}
